// extracted by mini-css-extract-plugin
export var button = "_al-0";
export var icon = "_al-1";